var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDownGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 11.334C7.88855 11.334 7.78392 11.3149 7.68626 11.2767C7.5886 11.2386 7.49792 11.1737 7.41421 11.0821L3.56369 6.86834C3.41023 6.7004 3.3335 6.48666 3.3335 6.22711C3.3335 5.96757 3.41023 5.75383 3.56369 5.58589C3.71715 5.41795 3.91247 5.33398 4.14964 5.33398C4.38681 5.33398 4.58213 5.41795 4.73559 5.58589L8.00016 9.15841L11.2647 5.58589C11.4182 5.41795 11.6135 5.33398 11.8507 5.33398C12.0879 5.33398 12.2832 5.41795 12.4366 5.58589C12.5901 5.75383 12.6668 5.96757 12.6668 6.22711C12.6668 6.48666 12.5901 6.7004 12.4366 6.86834L8.58611 11.0821C8.5024 11.1737 8.41172 11.2386 8.31406 11.2767C8.21641 11.3149 8.11177 11.334 8.00016 11.334Z",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownGrey);
export default __webpack_public_path__ + "static/media/chevron_down_grey.2d060b7ab79f3204aed39415f137c436.svg";
export { ForwardRef as ReactComponent };